export default __webpack_public_path__ + "c42fefdcfa17c664d9f13122bfc85957.png";